"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBox = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var lodash_1 = require("lodash");
var input_with_options_1 = require("wix-ui-core/input-with-options");
var button_next_1 = require("wix-ui-core/button-next");
var ClearButton_1 = require("../ClearButton");
var SearchIcon_1 = require("../SearchIcon");
var SuggestionFooter_1 = require("../SuggestionFooter");
var getSuggestionsOptions_1 = require("./getSuggestionsOptions");
var constants_1 = require("./constants");
var elements_1 = require("./measure/elements");
var SearchBox_st_css_1 = require("./SearchBox.st.css");
var focusRing_1 = require("./focusRing");
function getCSSVariables(_a) {
    var _b;
    var fontSize = _a.fontSize, _c = _a.textSpacing, textSpacing = _c === void 0 ? 12 : _c, _d = _a.iconSpacing, iconSpacing = _d === void 0 ? 12 : _d, suggestionsMaxHeight = _a.suggestionsMaxHeight, bottomBorderWidth = _a.bottomBorderWidth, borderBottomColor = _a.borderBottomColor, expandedWidth = _a.expandedWidth;
    var variables = (_b = {},
        _b[SearchBox_st_css_1.vars['text-spacing']] = textSpacing + "px",
        _b[SearchBox_st_css_1.vars['icon-spacing']] = iconSpacing + "px",
        _b[SearchBox_st_css_1.vars['suggestions-max-height']] = constants_1.SUGGESTIONS_MAX_HEIGHT + "px",
        _b[SearchBox_st_css_1.vars['suggestions-top-border-width']] = "" + bottomBorderWidth,
        _b[SearchBox_st_css_1.vars['suggestions-top-border-color']] = "" + borderBottomColor,
        _b);
    if (fontSize) {
        variables[SearchBox_st_css_1.vars['font-size']] = fontSize;
    }
    if (expandedWidth) {
        variables[SearchBox_st_css_1.vars['expanded-width']] = expandedWidth + "px";
    }
    if (suggestionsMaxHeight) {
        variables[SearchBox_st_css_1.vars['suggestions-max-height']] = suggestionsMaxHeight + "px";
    }
    return variables;
}
var alwaysTrue = function () { return true; };
var isFederated = function (suggestions) {
    return Boolean(suggestions && 'items' in suggestions);
};
var SearchBox = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBox, _super);
    function SearchBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            collapsed: true,
            suggestionsMaxHeight: null,
            bottomBorderWidth: null,
            bottomBorderColor: null,
            isInputFocused: false,
        };
        _this.suggestionOptionIdsMap = null;
        _this.baseId = lodash_1.uniqueId('SearchBox');
        _this.handleClearValue = function () {
            if (_this.props.onClear) {
                _this.props.onClear();
            }
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            if (_this.props.onSubmit) {
                _this.props.onSubmit(e);
            }
            _this.blur();
        };
        _this.handleInputContainerClick = function () {
            _this.inputRef.focus();
        };
        _this.handleInputRef = function (ref) {
            _this.inputRef = ref;
        };
        _this.handleFormRef = function (ref) {
            _this.formRef = ref;
        };
        _this.handleInputWithOptionsRef = function (ref) {
            _this.inputWithOptionsRef = ref;
        };
        _this.handleBlur = function (e) {
            if (_this.props.isExpandable) {
                // TODO: SER-305 use layout after db update
                _this.setState({ collapsed: true });
            }
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };
        _this.handleSuggestionSelect = function (option) {
            if (!_this.props.suggestions || _this.suggestionOptionIdsMap === null) {
                return;
            }
            if (isFederated(_this.props.suggestions) && _this.props.onSuggestionClick) {
                _this.props.onSuggestionClick({
                    data: _this.props.suggestions.items[option.id].data,
                });
                return;
            }
            var params = _this.suggestionOptionIdsMap.get("" + option.id);
            if (!params) {
                return;
            }
            switch (params.type) {
                case "Option" /* Option */: {
                    var suggestion = params.suggestion;
                    if (_this.props.onSuggestionClick) {
                        _this.props.onSuggestionClick(suggestion, {
                            globalIndex: params.globalIndex,
                            groupId: params.groupId,
                            query: _this.props.value || '',
                        });
                    }
                    break;
                }
                case "Header" /* Header */: {
                    var group = params.group;
                    if (_this.props.onSuggestionShowAllClick) {
                        _this.props.onSuggestionShowAllClick({
                            url: group.url,
                            query: _this.props.value || '',
                            groupId: group.groupId,
                        });
                    }
                    break;
                }
                default:
            }
            _this.blur();
        };
        _this.handleFocus = function (e) {
            if (_this.props.isExpandable) {
                // TODO: SER-305 use layout after db update
                _this.setState({ collapsed: false });
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(e);
            }
            if (_this.inputWithOptionsRef && _this.shouldRenderSuggestions()) {
                _this.openSuggestions();
            }
            if (!_this.formRef) {
                return;
            }
            if (_this.shouldRenderSuggestions()) {
                _this.equalizeSuggestionBorders();
            }
            var rect = _this.formRef.getBoundingClientRect();
            /**
             * NOTE: "window" should not affect ssr because `handleFocus` runs only at client
             */
            var availableSpace = window.innerHeight - rect.bottom;
            var suggestionsMaxHeight = null;
            if (availableSpace <
                constants_1.SUGGESTIONS_MAX_HEIGHT +
                    constants_1.SUGGESTIONS_BOTTOM_MARGIN +
                    constants_1.SUGGESTIONS_FOOTER_HEIGHT) {
                suggestionsMaxHeight =
                    availableSpace - constants_1.SUGGESTIONS_BOTTOM_MARGIN - constants_1.SUGGESTIONS_FOOTER_HEIGHT;
                if (suggestionsMaxHeight < constants_1.SUGGESTIONS_MIN_HEIGHT) {
                    suggestionsMaxHeight = constants_1.SUGGESTIONS_MIN_HEIGHT;
                }
            }
            _this.setState({
                suggestionsMaxHeight: suggestionsMaxHeight,
            });
        };
        _this.handleSubmitButtonClick = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    SearchBox.prototype.closeSuggestions = function () {
        if (this.inputWithOptionsRef) {
            this.inputWithOptionsRef.close();
        }
    };
    SearchBox.prototype.openSuggestions = function () {
        if (this.inputWithOptionsRef) {
            this.inputWithOptionsRef.open();
        }
    };
    SearchBox.prototype.focus = function () {
        if (this.inputRef) {
            this.inputRef.focus();
        }
    };
    SearchBox.prototype.blur = function () {
        if (this.inputRef) {
            this.inputRef.blur();
        }
    };
    SearchBox.prototype.equalizeSuggestionBorders = function () {
        if (!this.formRef) {
            return;
        }
        var formRef = this.formRef;
        // popoverElement - trigger element (input)
        var popoverElement = elements_1.getPopoverElement(formRef);
        // popoverContentElement - dropdown's content (suggestions)
        var popoverContentElement = elements_1.getPopoverContentElement(formRef);
        if (!popoverElement || popoverContentElement) {
            return;
        }
        var popoverElementStyles = window.getComputedStyle(popoverElement);
        var bottomBorderWidth = popoverElementStyles.borderBottomWidth;
        var bottomBorderColor = popoverElementStyles.borderBottomColor;
        if (this.state.bottomBorderWidth !== bottomBorderWidth ||
            this.state.bottomBorderColor !== bottomBorderColor) {
            this.setState({
                bottomBorderWidth: bottomBorderWidth,
                bottomBorderColor: bottomBorderColor,
            });
        }
    };
    SearchBox.prototype.shouldRenderClearIcon = function () {
        return !!(this.props.onClear && !this.props.disabled);
    };
    SearchBox.prototype.shouldShowClearIcon = function () {
        return !!this.props.value;
    };
    SearchBox.suggestionsAreNotEmpty = function (suggestions) {
        if (!suggestions) {
            return false;
        }
        if ('groups' in suggestions) {
            return Boolean(suggestions.groups && suggestions.groups.length !== 0);
        }
        if ('options' in suggestions) {
            return Boolean(suggestions.options && suggestions.options.length !== 0);
        }
        if (isFederated(suggestions)) {
            return Boolean(suggestions.items.length);
        }
        return false;
    };
    SearchBox.prototype.shouldRenderSuggestions = function () {
        return SearchBox.suggestionsAreNotEmpty(this.props.suggestions);
    };
    SearchBox.prototype.getSuggestions = function () {
        this.suggestionOptionIdsMap = null;
        if (!this.shouldRenderSuggestions()) {
            return [];
        }
        var _a = getSuggestionsOptions_1.getSuggestionsOptions({
            suggestions: this.props.suggestions,
            //TODO: remove hardoced translation when https://github.com/wix-private/wix-ui-santa/pull/1680 is merged
            showAllText: this.props.translate
                ? this.props.translate(constants_1.translations.showAll)
                : 'Show all',
        }), options = _a.options, suggestionOptionIdsMap = _a.suggestionOptionIdsMap;
        this.suggestionOptionIdsMap = suggestionOptionIdsMap;
        return options;
    };
    SearchBox.prototype.getSuggestionsFooter = function () {
        if (!this.shouldRenderSuggestions()) {
            return null;
        }
        if (isFederated(this.props.suggestions)) {
            return (React.createElement(SuggestionFooter_1.SuggestionFooter, { text: this.props.suggestions.footer.text, url: this.props.suggestions.footer.url, onClick: this.props.onSuggestionSearchAllClick, height: constants_1.SUGGESTIONS_FOOTER_HEIGHT }));
        }
        return (React.createElement(SuggestionFooter_1.SuggestionFooter, { searchAllText: 
            //TODO: remove hardoced translation when https://github.com/wix-private/wix-ui-santa/pull/1680 is merged
            this.props.translate
                ? this.props.translate(constants_1.translations.searchAll)
                : 'Search all', searchQuery: this.props.suggestions.query, url: this.props.suggestions.searchAllUrl, onClick: this.props.onSuggestionSearchAllClick, height: constants_1.SUGGESTIONS_FOOTER_HEIGHT }));
    };
    SearchBox.prototype.getRegularInputProps = function () {
        var _a = this.props, withButton = _a.withButton, _b = _a.buttonAlignment, buttonAlignment = _b === void 0 ? 'right' : _b, withIcon = _a.withIcon, _c = _a.iconAlignment, iconAlignment = _c === void 0 ? 'left' : _c;
        return {
            prefix: (React.createElement(React.Fragment, null,
                withButton && buttonAlignment === 'left' ? this.getButton() : null,
                withIcon && iconAlignment === 'left' ? this.getIcon() : null)),
            suffix: (React.createElement(React.Fragment, null,
                this.shouldRenderClearIcon() ? (React.createElement(ClearButton_1.ClearButton, { onClick: this.handleClearValue, className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes.clearButton), "data-hook": "clear-button", "aria-label": 
                    //TODO: remove hardoced translation when https://github.com/wix-private/wix-ui-santa/pull/1680 is merged
                    this.props.translate
                        ? this.props.translate(constants_1.translations.clearLabel)
                        : '{clearLabel}' })) : null,
                withIcon && iconAlignment === 'right' ? this.getIcon() : null,
                withButton && buttonAlignment === 'right' ? this.getButton() : null)),
        };
    };
    SearchBox.prototype.getExpandableInputProps = function () {
        return {
            prefix: this.props.expandedDirection === 'right' ? this.getIcon() : null,
            suffix: this.props.expandedDirection === 'left' ? this.getIcon() : null,
        };
    };
    SearchBox.prototype.getInputProps = function () {
        var _this = this;
        return tslib_1.__assign({ 'aria-label': this.props.placeholder, value: this.props.value, onChange: this.props.onChange, onFocus: function (e) {
                _this.handleFocus(e);
                _this.setState({ isInputFocused: true });
            }, onBlur: function (e) {
                _this.handleBlur(e);
                _this.setState({ isInputFocused: false });
            }, placeholder: this.props.placeholder, name: 'search', autoComplete: 'off', ref: this.handleInputRef, disabled: !!this.props.disabled, type: 'search' }, (this.props.isExpandable // TODO: SER-305 use layout after db update
            ? this.getExpandableInputProps()
            : this.getRegularInputProps()));
    };
    SearchBox.prototype.getButton = function () {
        /* has-custom-focus indicates that the component has a custom focus
         * implementation and does not need the default wix-focus-ring applied
         */
        var buttonClassName = SearchBox_st_css_1.st(SearchBox_st_css_1.classes.button, 'has-custom-focus');
        return (React.createElement(button_next_1.ButtonNext, { "aria-label": this.props.placeholder, className: buttonClassName, "data-hook": "search-button", onClick: this.handleSubmitButtonClick, type: "submit" },
            React.createElement(SearchIcon_1.SearchIcon, { className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes['button-icon']), "data-hook": "search-icon" })));
    };
    SearchBox.prototype.getIcon = function () {
        return (React.createElement(SearchIcon_1.SearchIcon, { className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes.icon), "data-hook": "search-icon", maintainProportions: this.props.isExpandable }));
    };
    SearchBox.prototype.render = function () {
        var _a = this.props, withIcon = _a.withIcon, _b = _a.textAlignment, textAlignment = _b === void 0 ? 'left' : _b, _c = _a.iconAlignment, iconAlignment = _c === void 0 ? 'left' : _c, withButton = _a.withButton, _d = _a.buttonAlignment, buttonAlignment = _d === void 0 ? 'right' : _d, previewState = _a.previewState;
        var withClearIcon = this.shouldShowClearIcon();
        var cssVariables = getCSSVariables({
            fontSize: this.props.fontSize,
            textSpacing: this.props.textSpacing,
            iconSpacing: this.props.iconSpacing,
            suggestionsMaxHeight: this.state.suggestionsMaxHeight,
            bottomBorderWidth: this.state.bottomBorderWidth,
            borderBottomColor: this.state.bottomBorderColor,
            expandedWidth: this.props.expandedWidth,
        });
        var states = {
            withClearIcon: withClearIcon,
            iconAlignment: withIcon ? iconAlignment : 'none',
            textAlignment: textAlignment,
            buttonAlignment: withButton ? buttonAlignment : 'none',
            previewStateHover: previewState === 'hover',
            previewStateFocus: previewState === 'focus',
            withOverrideFontSize: !!this.props.fontSize,
            withSuggestions: this.shouldRenderSuggestions(),
            shouldShowClearIcon: this.shouldShowClearIcon(),
            withSuggestionsTopBorder: this.state.bottomBorderWidth !== null ||
                this.state.bottomBorderColor !== null,
            disabled: !!this.props.disabled,
            isExpandable: !!this.props.isExpandable,
            collapsed: !previewState && this.state.collapsed,
            expandedDirection: this.props.expandedDirection || 'right',
            withFocusRing: focusRing_1.isFocusRingEnabled(),
            inputFocused: this.state.isInputFocused,
        };
        return (React.createElement("form", { action: "#", className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes.root, states, this.props.className), "data-hook": "search-box-form", onSubmit: this.handleSubmit, ref: this.handleFormRef, role: "search", style: cssVariables },
            React.createElement("div", { onClick: this.handleInputContainerClick, "data-hook": "input-with-options-container", className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes.inputContainer) },
                React.createElement(input_with_options_1.InputWithOptions, { className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes.input), forceContentElementVisibility: this.props.forceContentElementVisibility, 
                    // pass null to remove default inputWithOptions behaviour to show options on hover/click
                    // @ts-ignore
                    openTrigger: null, ref: this.handleInputWithOptionsRef, inputProps: this.getInputProps(), "data-hook": "input-with-options", fixed: true, flip: false, onSelect: this.handleSuggestionSelect, allowReselect: true, options: this.getSuggestions(), fixedFooter: this.getSuggestionsFooter(), filterPredicate: alwaysTrue, id: (this.props.baseId || this.baseId) + "-inputwithoptions" }))));
    };
    SearchBox.defaultProps = {
        suggestions: [],
        withIcon: true,
        textAlignment: 'left',
        iconAlignment: 'left',
        withButton: false,
        buttonAlignment: 'right',
        isExpandable: false,
        expandedWidth: 280,
        expandedDirection: 'right',
    };
    return SearchBox;
}(React.Component));
exports.SearchBox = SearchBox;
exports.default = SearchBox;
//# sourceMappingURL=SearchBox.js.map